import { useCallback, useState } from "react"

import type { OpenedScreens } from "../types"

const STORAGE_KEY = "today_opened_screens"

function read(): OpenedScreens {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return raw ? (JSON.parse(raw) as OpenedScreens) : {}
  } catch {
    return {}
  }
}

/**
 * Tracks which daily category screens the user has already revealed (e.g. the
 * "number of the day" tap-to-open). Persisted in localStorage so it survives
 * reloads within the same day.
 */
export function useOpenedScreens() {
  const [opened, setOpened] = useState<OpenedScreens>(read)

  const open = useCallback((key: string) => {
    setOpened((prev) => {
      if (prev[key]) return prev
      const next = { ...prev, [key]: true }
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
      } catch {
        // ignore persistence failures
      }
      return next
    })
  }, [])

  const isOpened = useCallback((key: string) => Boolean(opened[key]), [opened])

  return { isOpened, open }
}
